// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"158f1c68","165":"d5682003","239":"e71c80ac","455":"8e736712","507":"4700417e","599":"1648f4da","875":"d354c8c3","888":"9b8c3e5e","897":"859a1e29","977":"3515043f"}[chunkId] + ".chunk.js";
};